import React from 'react'
import './styles.scss'

function Textbox(props) {
  const y = props.pos * props.linespace + props.titleOffset
  const styles = { top: y }
  return (
    <div className='textbox_wrapper' style={styles}>
      <div className={`dot ${props.align}`}>
        {/* <span>{props.accurate ? props.pos : Math.round(props.pos)} Mio.</span> */}
        <span>{parseFloat(props.pos).toFixed(1)} Mio.</span>
      </div>
      <div className='ui text textbox'>{props.children}</div>
    </div>
  )
}

function History(props) {
  const y = props.pos * props.linespace + props.titleOffset
  const hideMobile = props.hideOnMobile ? 'hideonmobile' : ''
  return (
    <div
      className={`ui text history ${props.align} ${hideMobile}`}
      style={{ top: y }}
    >
      <span className='dot' />
      <span className='value'>{props.value}</span>
      {props.children}
      <span className='value_mobile'>{props.value}</span>
    </div>
  )
}

function SVGTimeline(props) {
  const linesDesktop = []
  const linesMobile = []
  let i = props.from
  let count = 0
  while (i < props.to) {
    const y = count * props.linespace + props.titleOffset

    const xd1 = count % 10 === 0 ? 50 : 60
    // Add Line Desktop
    linesDesktop.push(
      <line
        x1={xd1}
        y1={y}
        x2='70'
        y2={y}
        className='line'
        shapeRendering='crispEdges'
        key={`line_${i}`}
      />
    )

    // Add Text
    if (count % 10 === 0) {
      linesDesktop.push(
        <text
          x='44'
          y={y + 5}
          className='number'
          key={`text_${count}`}
          textAnchor='end'
        >
          {i}
        </text>
      )
    }

    // Add Line Mobile
    linesMobile.push(
      <line
        x1={5}
        y1={y}
        x2={count % 10 === 0 ? 10 : 8}
        y2={y}
        className='line'
        shapeRendering='crispEdges'
        key={`line_${i}`}
      />
    )

    // Add Text
    if (count % 10 === 0) {
      linesMobile.push(
        <text x='13' y={y + 3} className='number' key={`text_${count}`}>
          {i}
        </text>
      )
    }

    i += props.step
    count++
  }

  return (
    <>
      <svg
        width='150'
        height={props.height}
        id='timeline_svg_desktop'
        viewBox={`0 0 150 ${props.height}`}
      >
        <text x='30' y={props.titleOffset - 25} className='number'>
          Millionen
        </text>
        {linesDesktop}
      </svg>

      <svg
        width='45'
        height={props.height}
        id='timeline_svg_mobile'
        viewBox={`0 0 45 ${props.height}`}
      >
        <text x='0' y={props.titleOffset - 25} className='number'>
          Mio.
        </text>
        {linesMobile}
      </svg>
    </>
  )
}

function Timeline(props) {
  const height = ((props.to - props.from) / props.step) * props.linespace
  let sumTextBox = 0
  // var dotCount = 0;

  return (
    <div className='timeline' style={{ height: height }}>
      <div className='verticalline' />

      <div id='body'>
        <SVGTimeline
          titleOffset={props.titleOffset}
          height={height}
          to={props.to}
          from={props.from}
          step={props.step}
          linespace={props.linespace}
        />
        {props.children.map((e, i) => {
          let pos = e.props.pos
          // if([Textbox, History].includes(e.type))
          // {
          //   dotCount++;
          // }
          if (e.type === Textbox) {
            if (e.props.value) {
              sumTextBox += e.props.value
              pos = sumTextBox
            }
          }
          return React.cloneElement(e, {
            pos: pos,
            linespace: props.linespace,
            titleOffset: props.titleOffset,
            // anchor: dotCount % 2 === 0 ? 'left' : 'right',
            key: i
          })
        })}
      </div>
    </div>
  )
}

function Separator(props) {
  const y = props.pos * props.linespace + props.titleOffset
  return (
    <div className='separator' style={{ top: y }}>
      <div className='linewrapper'>
        <div className='line' />
        <div className='title'>{props.title}</div>
      </div>
      {props.children && (
        <div className='textbox_wrapper'>
          <div className='ui text textbox'>{props.children}</div>
        </div>
      )}
    </div>
  )
}

export { SVGTimeline, Timeline, Textbox, History, Separator }
